import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { ISmartResultGridCoverage } from '../iris/smartMission/ISmartResultGridCoverage'
import { AloDbMissionGlobal } from './AloDbMissionGlobal'
import { ISmartSimulation } from '../iris/smartMission/ISmartSimulation'
import { ISmartResult } from '../iris/smartMission/ISmartResult'
import { AloMission } from '../alo/AloMission'
import { AloYo } from '../alo/AloYo'
import { boundingExtent } from 'ol/extent';
import { isDate } from 'lodash'
import { ISmartSimulationCoverage } from '../iris/smartMission/ISmartSimulationCoverage'
import { CoverageState, getCoverageState } from '@/enum/CoverageState'

export interface IAloDbCoverageIterationConstParam extends IAloDbBaseConstParam {
    COV_ID:number|null    
    COV_LIBELLE:string|null    
    COV_COMPANY:string|null
    COV_DATEXEC:string|null    
    COV_IRIS_RESULT_FULL_JSON:string|null    
    COV_IRIS_RESULT_GRID_JSON:string|null    
    COV_IRIS_RESULT_MIP_JSON:string|null     
    COV_ITERATION:number|null   
    COV_NAME:string|null
    COV_PARAM_JSON:string|null
    COV_PROCESSING_STATE:string|null
    COV_PROCESSING_STEP:string|null
    COV_ESTIMATED_END_DATE:string|null
    MIG_ID:number|null
  }

export class AloDbCoverageIteration extends AloDbBase {
        
    public COV_ID:number|null
    public COV_LIBELLE:string|null
    public COV_COMPANY:string|null
    public COV_DATEXEC:Date|null   
    public COV_IRIS_RESULT_FULL_JSON:string|null    
    public COV_IRIS_RESULT_GRID_JSON:string|null    
    public COV_IRIS_RESULT_MIP_JSON:string|null     
    public COV_ITERATION:number|null   
    public COV_NAME:string|null
    public COV_PARAM_JSON:string|null
    public COV_PROCESSING_STATE:string|null
    public COV_PROCESSING_STEP:string|null
    public COV_ESTIMATED_END_DATE:Date|null
    public MIG_ID:number|null

    
    public config:ISmartSimulationCoverage|null
    public resultGridJson:ISmartResultGridCoverage|null
    public resultMipJson:{[glider:string]:ISmartSimulation}|null
    public resultFullJson:{[glider:string]:ISmartResult}|null    
    public resultAloMission:{[glider:string]:AloMission}|null  
    
    public distance_traveled:number|null
    public missionStartDate:Date|null   
    public missionCurEndDate:Date|null   
    public nbYos:number|null
    public energy_available:number|null
    
    constructor({COV_ID,COV_LIBELLE,COV_COMPANY,COV_DATEXEC,COV_IRIS_RESULT_FULL_JSON,COV_IRIS_RESULT_GRID_JSON,COV_IRIS_RESULT_MIP_JSON,COV_ITERATION,COV_NAME,COV_PARAM_JSON,COV_PROCESSING_STATE,COV_PROCESSING_STEP,COV_ESTIMATED_END_DATE,MIG_ID,...args }:IAloDbCoverageIterationConstParam = {} as IAloDbCoverageIterationConstParam) {
        super(args)
        this.COV_ID = COV_ID
        this.COV_LIBELLE = COV_LIBELLE           
        this.COV_COMPANY = COV_COMPANY
        this.COV_DATEXEC =  COV_DATEXEC?new Date(COV_DATEXEC):null     
        this.COV_IRIS_RESULT_FULL_JSON = COV_IRIS_RESULT_FULL_JSON        
        this.COV_IRIS_RESULT_GRID_JSON = COV_IRIS_RESULT_GRID_JSON        
        this.COV_IRIS_RESULT_MIP_JSON = COV_IRIS_RESULT_MIP_JSON        
        this.COV_ITERATION = COV_ITERATION        
        this.COV_NAME = COV_NAME        
        this.COV_PARAM_JSON = COV_PARAM_JSON        
        this.COV_PROCESSING_STATE = COV_PROCESSING_STATE        
        this.COV_PROCESSING_STEP = COV_PROCESSING_STEP        
        this.COV_ESTIMATED_END_DATE = COV_ESTIMATED_END_DATE?new Date(COV_ESTIMATED_END_DATE.endsWith("Z")?COV_ESTIMATED_END_DATE:COV_ESTIMATED_END_DATE+"Z"):null          
        this.MIG_ID = MIG_ID       
        
        this.config = JSON.parse(this.COV_PARAM_JSON || '{}') 
        this.resultGridJson = AloDbMissionGlobal.parseIrisResultGridCoverage(COV_IRIS_RESULT_GRID_JSON)            
        this.resultMipJson = JSON.parse(this.COV_IRIS_RESULT_MIP_JSON || '{}') 
        this.resultFullJson = JSON.parse(this.COV_IRIS_RESULT_FULL_JSON || '{}')         
        const gliderKey = Object.keys(this.resultMipJson || {}).filter(n => n.startsWith('GLIDER'))
       
        var distance_traveled = 0
        var nbYos = 0
        var energy_available=0
        var missionStartDate = null as Date|null
        var missionCurEndDate = null as Date|null
            
        //@ts-ignore
        this.resultAloMission = gliderKey.reduce((acc:{[glider:string]:AloMission},key:string,idx) => {
            //@ts-ignore
            acc[key] = AloDbCoverageIteration.buildCovMission(this.COV_ID, this.resultFullJson?.[key],idx,key,this.resultMipJson?.[key])

            //Calcul des valeurs globales du resultat
            
            distance_traveled += acc[key]?.result?.distance_traveled??0
            nbYos += acc[key]?.result?.cycle_number??0
            energy_available += acc[key]?.result?.energy_available??0

            //@ts-ignore
            const misStartDate = acc?.[key]?.param?.mission_start_date?new Date(acc[key].param.mission_start_date!):null
            //@ts-ignore
            const misEndDate = acc?.[key]?.result?.mission_end_date?new Date(acc[key].result.mission_end_date!):null

            if(isDate(misStartDate)) missionStartDate = (missionStartDate == null || misStartDate < missionStartDate)?misStartDate:missionStartDate
            if(isDate(misEndDate)) missionCurEndDate = (missionCurEndDate == null || misEndDate < missionCurEndDate)?misEndDate:missionCurEndDate                        

            return acc
        },{})

        this.distance_traveled = distance_traveled
        this.missionStartDate = missionStartDate
        this.missionCurEndDate = missionCurEndDate
        this.nbYos = nbYos
        this.energy_available = energy_available
        

    }
    

    static buildCovMission(covId:number,smartResult:ISmartResult,misIdx:number,glider:string,param:any)
    {
          const mesureTypeExArray = [
                {MET_KEY:"SIMU_TEMPERATURE",mesureUniteEx:{MUT_SYMBOL:"°"},MET_CONFIG_JSON:JSON.stringify({name:"Température"})},
                {MET_KEY:"SIMU_SALINITY",mesureUniteEx:{MUT_SYMBOL:"PSU"},MET_CONFIG_JSON:JSON.stringify({name:"Salinity"})}
            ]
    
            //@ts-ignore                    
            const mission =  new AloMission({covId,detailLoaded: true,misId:-(misIdx+1),misIdx,misLibelle:glider,gliId:-1,ensId:-1,yoArray:smartResult?.surfacing_points?.map((s,idx) => ({
                yosId:(-idx),
                //@ts-ignore
                yosCycle:s?.at(0),heading:s?.at(4),cr:s?.at(6),cf:s?.at(5),yoGpsLat:s?.at(2),yoGpsLon:s?.at(3),yoGpsDatTime:s?.at(1),batteries:s?.at(7)
            }))  ?? []
            //@ts-ignore 
            ,isVirtual:true,mesureTypeExArray})
    
            //on prend en compte les points du mission plan pour la zone de zoom auto
            //const gpsPoint =  missionvirtual.param.mission_plan.wpts?.filter(wpt => wpt.wpt_lat !=null && wpt.wpt_lon != null)?.map(wpt => [wpt.wpt_lon,wpt.wpt_lat]) ?? []
            //@ts-ignore
            const yos = mission.yoArray.filter(y => y.yoGpsLat !=null && y.yoGpsLon != null)?.map(y => [y.yoGpsLon!, y.yoGpsLat!]) ?? []    
            //mission._extent = boundingExtent([...gpsPoint,...yos])              
            mission._extent = boundingExtent([...yos])              

            mission.result = smartResult
            mission.param = param
                       
            return mission
    }

    static buildYos(smartResult?:ISmartResult,detailLoaded=false)
    {
        return smartResult?.surfacing_points?.map((s,idx) => {
            //@ts-ignore
            const yof = new AloYo({
                yosId:(-idx),
                //@ts-ignore 
                yosCycle:s?.at(0),heading:s?.at(4),cr:s?.at(6),cf:s?.at(5),yoGpsLat:s?.at(2),yoGpsLon:s?.at(3),yoGpsDatTime:s?.at(1),batteries:s?.at(7)
            })
            Object.freeze(yof)
            return yof

        }) || []
    }

    static createAloDbCoverageIterationArray(datas:any) {
        return new AloBaseArray(AloDbCoverageIteration,datas)
    }

    static createAloDbCoverageIterationWithDetail(data:any) {
        return new AloDbCoverageIteration({...data,detailLoaded:true})
    }
}
